<button
  type="button"
  class="btn btn-accent rounded-pill"
  (click)="openWhatsApp()"
>
  {{ buttonText }}
</button>
